var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle121(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "212.5587017655343 386.20649169511984 15.57175866887772 15.67597062134979",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M219.94,397.88c-1.97-.07-3.53-1.81-3.37-3.76.18-2.25,2.26-4.09,4.41-3.9,1.74.15,3.18,1.79,3.15,3.57-.04,2.29-1.97,4.17-4.19,4.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle121);
export default __webpack_public_path__ + "static/media/twinkle-1-21.f569ccc3552febb866bc75678d2dd248.svg";
export { ForwardRef as ReactComponent };